import App from './App'

Vue.use(Vuetify)

new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js